module.exports = __webpack_public_path__ + "img/ChartPie-old.95c5f461.jpg";